import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as regulatoryState from '../auth.reducer';
import * as regulatoryReducer from '../reducers/get-regulatory.reducer';

export const getRegulatory = createSelector(regulatoryState.getRegulatoryState, regulatoryReducer.getRegulatory);

export const getRegulatoryLoaded = createSelector(regulatoryState.getRegulatoryState, regulatoryReducer.getRegulatoryLoaded);
